import React, { useEffect, useState } from "react";
import moment from "moment";
import { toast } from "react-toastify";

import Modal from "../../../../components/Modal";
import Button from "../../../../components/Button";
import Input from "../../../../components/Input";
import InputSelect from "../../../../components/InputSelect";
import InputDate from "../../../../components/InputDate";

import api from "../../../../services/api";
import { renderError } from "../../../../helpers/errors";
import { convertIntToMoney, convertMoenyToInt } from "../../../../helpers/conversions";

export const ModalTransfer = ({ show, close, transfer, bankAccounts, onSaved }) => {
    const [saving, setSaving] = useState(false);
    const [fromAccountId, setFromAccountId] = useState(null);
    const [toAccountId, setToAccountId] = useState(null);
    const [amount, setAmount] = useState('R$ 0,00');
    const [transferredAt, setTransferredAt] = useState('');
    const [description, setDescription] = useState('');

    useEffect(() => {
        if (!show) return;

        setFromAccountId(transfer?.from_finance_bank_account_id ?? null);
        setToAccountId(transfer?.to_finance_bank_account_id ?? null);
        setAmount(transfer ? convertIntToMoney(transfer.amount, true) : 'R$ 0,00');
        setTransferredAt(transfer ? moment(transfer.transferred_at).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'));
        setDescription(transfer?.description ?? '');
    }, [show]);

    const save = () => {
        setSaving(true);

        const payload = {
            from_finance_bank_account_id: fromAccountId,
            to_finance_bank_account_id: toAccountId,
            amount: convertMoenyToInt(amount),
            transferred_at: transferredAt,
            description: description || null,
        };

        const request = transfer
            ? api.put(`/finance-transfer/${transfer.id}`, payload)
            : api.post(`/finance-transfer`, payload);

        request.then(() => {
            toast.success(transfer ? 'Transferência atualizada' : 'Transferência registrada');
            close();
            onSaved();
        }).catch(renderError).then(() => setSaving(false));
    };

    const accountOptions = bankAccounts.map(account => ({ label: account.name, value: account.id }));

    return (
        <Modal
            title={transfer ? `Editar transferência` : `Nova transferência`}
            show={show}
            close={close}
            footer={<Button type={`primary`} size={`small`} text={`Salvar`} action={save} loading={saving} disabled={!fromAccountId || !toAccountId || fromAccountId === toAccountId} />}
        >
            <div className="section">
                <div className="row">
                    <div className="col-6">
                        <InputSelect label={`Da conta`} options={accountOptions} value={fromAccountId} change={setFromAccountId} />
                    </div>
                    <div className="col-6">
                        <InputSelect label={`Para a conta`} options={accountOptions} value={toAccountId} change={setToAccountId} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <Input label={`Valor`} value={amount} change={setAmount} mask={`convertToMoney`} />
                    </div>
                    <div className="col-6">
                        <InputDate label={`Data`} format={`YYYY-MM-DD`} value={transferredAt} change={setTransferredAt} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <Input label={`Descrição`} value={description} change={setDescription} />
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default ModalTransfer;
